const WELLNESS_PLAN = {
    STATUS_ACTIVE: 0,
    STATUS_EXPIRED: 1,
    STATUS_CANCELLED: 2,
    STATUS_AUTO_RENEWED: 3
};

export default {
    WELLNESS_PLAN
};
